function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HouseFill, Truck, PersonFillLock, CashCoin, Power, PieChartFill, Diagram3Fill, PeopleFill, FuelPumpFill, ArrowRepeat } from 'react-bootstrap-icons';
import { Container, Row, Col } from "react-bootstrap";
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { Icon } from "@iconify/react";
import { Layout, Menu, Modal, Button, message, Dropdown, Space, Image } from 'antd';
import Common from '../components/includes/Common';
import { DownOutlined, EllipsisOutlined, UserOutlined } from '@ant-design/icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Header = Layout.Header,
  Content = Layout.Content,
  Footer = Layout.Footer,
  Sider = Layout.Sider;
var Home = function Home() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    ContextHolder = _Modal$useModal2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNewCashierOpen = _useState2[0],
    setIsNewChashierOpen = _useState2[1];
  var _useState3 = useState(localStorage.getItem('menu_key')),
    _useState4 = _slicedToArray(_useState3, 2),
    currentMenuItem = _useState4[0],
    setCurrentMenuItem = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isCashierPerformed = _useState6[0],
    setIsCashierPerformed = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    authProcessing = _useState8[0],
    setAuthProcessing = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    items = _useState10[0],
    setItems = _useState10[1];
  var _useParams = useParams(),
    userid = _useParams.userid;
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    user = _useState12[0],
    setUser = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isDataLoading = _useState14[0],
    setIsDataLoading = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    stationList = _useState16[0],
    setStationList = _useState16[1];
  var navigate = useNavigate();
  var handleStationMenuClick = function handleStationMenuClick(e) {
    if (stationList.filter(function (s) {
      return s.id == e.key;
    }).length == 0) return;
    if (Common.currentStation != 'undefined' && Common.currentStation.id == e.key) return;
    var station = stationList.filter(function (s) {
      return s.id == e.key;
    })[0];
    confirm({
      title: /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(ArrowRepeat, {
          size: 30
        }), /*#__PURE__*/_jsx("h4", {
          children: /*#__PURE__*/_jsxs("b", {
            children: [" Passer \xE0 ", station.label, " ?"]
          })
        })]
      }),
      icon: null,
      onOk: function onOk() {
        if (Common.currentStation != 'undefined') localStorage.removeItem("stationData");
        localStorage.setItem("stationData", JSON.stringify(station));
        window.location.reload();
      },
      okText: /*#__PURE__*/_jsx("b", {
        children: "Confirmer"
      }),
      cancelText: "Retour"
    });
  };
  var menuProps = {
    items: items,
    onClick: handleStationMenuClick
  };
  var handleMenuClick = function handleMenuClick(e) {
    setCurrentMenuItem(e.key);
    localStorage.setItem('menu_key', e.key);
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.removeItem("userData");
          localStorage.removeItem("stationData");
          localStorage.removeItem("businessData");
          localStorage.removeItem("isOn");
          navigate('/');
        }
      })["catch"](function (error) {});
    }
  };
  var _useState17 = useState(true),
    _useState18 = _slicedToArray(_useState17, 2),
    collapsed = _useState18[0],
    setCollapsed = _useState18[1];
  useEffect(function () {
    var uid = Common.currentUser != null ? Common.currentUser.id : userid;
    axios.post(Common.baseApiUrl + 'authenticateuser', {
      id: uid
    }).then(function (response) {
      setAuthProcessing(false);
      if (response.data.auth == true) {
        setUser(response.data.user);
        localStorage.setItem('userData', JSON.stringify(response.data.user));
      } else {
        navigate('/');
        window.location.reload();
      }
    })["catch"](function (error) {});
    if (user == null) {
      setUser(Common.currentUser);
    }
  }, []);
  useEffect(function () {
    axios.get(Common.baseApiUrl + 'getautorizedstations/' + Common.currentUser.id).then(function (sresponse) {
      setIsDataLoading(true);
      if (sresponse.data.status == 200 && sresponse.data.stations.length > 0) {
        setItems([]);
        setStationList([]);
        sresponse.data.stations.forEach(function (s) {
          setStationList(function (prev) {
            return [].concat(_toConsumableArray(prev), [s]);
          });
          setItems(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              key: s.id,
              label: /*#__PURE__*/_jsxs("div", {
                children: [Common.currentStation != 'undefined' && s.id == Common.currentStation.id && /*#__PURE__*/_jsx("span", {
                  style: {
                    display: "inline-block",
                    width: "9px",
                    height: "9px",
                    borderRadius: "9px",
                    background: "#4BAD6B"
                  }
                }), " ", s.label]
              })
            }]);
          });
        });
        if (localStorage.getItem("stationData") == 'undefined' || localStorage.getItem("stationData") == null) {
          localStorage.setItem("stationData", JSON.stringify(sresponse.data.stations[0]));
        }
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: user != null ? /*#__PURE__*/_jsxs(Layout, {
      style: {
        minHeight: '100vh',
        padding: '0px'
      },
      children: [/*#__PURE__*/_jsxs(Sider, {
        collapsible: true,
        breakpoint: "lg",
        collapsed: collapsed,
        style: {
          background: "#1E1E1E"
        },
        onCollapse: function onCollapse(value) {
          return setCollapsed(value);
        },
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            height: 32,
            margin: 16,
            background: 'rgba(255, 255, 255, 0.2)'
          }
        }), /*#__PURE__*/_jsxs(Menu, {
          theme: "dark",
          style: {
            background: "#1E1E1E"
          },
          defaultSelectedKeys: currentMenuItem,
          onClick: handleMenuClick,
          mode: "inline",
          children: [/*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:statistics",
              width: "36",
              height: "36"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/dashboard",
              children: /*#__PURE__*/_jsx("b", {
                children: "Tableau de bord"
              })
            })
          }, "dash"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "streamline-ultimate-color:gas-f",
              width: "35",
              height: "35"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/agent",
              children: /*#__PURE__*/_jsx("b", {
                children: "Rapport de piste"
              })
            })
          }, "pump"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:currency-exchange",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/cashier",
              children: /*#__PURE__*/_jsx("b", {
                children: " Gestion Caisse"
              })
            })
          }, "cash"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:shipped",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/orders",
              children: /*#__PURE__*/_jsx("b", {
                children: "Commandes"
              })
            })
          }, "ord"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:debt",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/companies",
              children: /*#__PURE__*/_jsx("b", {
                children: "Comptes Clients"
              })
            })
          }, "cust"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:automatic",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/organisation",
              children: /*#__PURE__*/_jsx("b", {
                children: " Param\xE8tres"
              })
            })
          }, "org"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:positive-dynamic",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/reports",
              children: /*#__PURE__*/_jsx("b", {
                children: "Rapports"
              })
            })
          }, "stat"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:conference-call",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/users",
              children: /*#__PURE__*/_jsx("b", {
                children: "Utilisateurs"
              })
            })
          }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:contacts",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/home/account",
              children: /*#__PURE__*/_jsx("b", {
                children: "Mon profile"
              })
            })
          }, "account"), /*#__PURE__*/_jsx(Menu.Item, {
            icon: /*#__PURE__*/_jsx(Icon, {
              icon: "flat-color-icons:import",
              width: "38",
              height: "38"
            }),
            children: /*#__PURE__*/_jsx(Link, {
              to: "/",
              children: /*#__PURE__*/_jsx("b", {
                children: "D\xE9connexion"
              })
            })
          }, "quit")]
        })]
      }), /*#__PURE__*/_jsxs(Layout, {
        children: [/*#__PURE__*/_jsx(Header, {
          style: {
            borderBottom: '1px solid #EEE'
          },
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              lg: 1,
              md: 1,
              sm: 4,
              xs: 4,
              children: /*#__PURE__*/_jsx("div", {
                style: {
                  paddingLeft: "0px"
                },
                children: /*#__PURE__*/_jsx(Image, {
                  preview: false,
                  src: "drawables/ss.png",
                  width: "125px"
                })
              })
            }), /*#__PURE__*/_jsx(Col, {
              lg: {
                span: 2,
                offset: 7
              },
              md: {
                span: 2,
                offset: 9
              },
              sm: {
                span: 5,
                offset: 3
              },
              xs: {
                span: 6,
                offset: 2
              },
              children: /*#__PURE__*/_jsxs("div", {
                style: {
                  textAlign: "right",
                  marginLeft: "auto"
                },
                children: [ContextHolder, /*#__PURE__*/_jsxs(Space.Compact, {
                  separator: "",
                  children: [/*#__PURE__*/_jsxs(Button, {
                    type: "primary",
                    icon: /*#__PURE__*/_jsx(FuelPumpFill, {}),
                    style: {
                      background: "#2D544E"
                    },
                    children: [" ", /*#__PURE__*/_jsx("b", {
                      children: /*#__PURE__*/_jsx("span", {
                        style: {
                          textTransform: "uppercase"
                        },
                        children: Common.currentStation != 'undefined' && Common.currentStation.label
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Dropdown, {
                    menu: menuProps,
                    placement: "bottomRight",
                    children: /*#__PURE__*/_jsx(Button, {
                      type: "primary",
                      style: {
                        background: "#3E7455"
                      },
                      icon: /*#__PURE__*/_jsx(ArrowRepeat, {})
                    })
                  })]
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Content, {
          style: {
            padding: '0 5px',
            marginTop: 74
          },
          children: /*#__PURE__*/_jsx("div", {
            className: "site-layout-background",
            style: {
              padding: 0,
              minHeight: 380
            },
            children: /*#__PURE__*/_jsx(Outlet, {
              context: [isCashierPerformed, setIsCashierPerformed]
            })
          })
        }), /*#__PURE__*/_jsx(Footer, {
          style: {
            textAlign: 'center'
          },
          children: "Guisoft Lab \xA92023, tous droits r\xE9serv\xE9s"
        })]
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};
export default Home;